<div class="filter-time-range">
  <div
    class="filter-time-range__input-group vox-input-group vox-input-group_dense"
    (clickOutside)="closePopover()">
    <div
      class="filter-time-range__input-opening"
      (click)="togglePopover()">
      <input
        type="text"
        readonly
        class="filter-time-range__input vox-text-field"
        [value]="formattedRange" />
      <i class="filter-time-range__input-icon icon-small-trial"></i>
    </div>
    <div
      class="filter-time-range__popover"
      *ngIf="popoverOpen">
      <div class="filter-time-range__container">
        <div class="filter-time-range__from">
          <app-filter-time
            [time]="_fromTime"
            [maxTime]="_toLimit"
            [minTime]="minTime"
            (changeTime)="onChangeFromTime($event)"></app-filter-time>
        </div>
        <div class="filter-time-range__to">
          <app-filter-time
            [time]="_toTime"
            [maxTime]="maxTime"
            [minTime]="_fromLimit"
            (changeTime)="onChangeToTime($event)"></app-filter-time>
        </div>
      </div>
    </div>
  </div>
</div>
